import { SUBCONTRACTOR_TYPE } from '@/shared/types/auth.types';
import type { User } from '@/shared/types/auth.types';

/**
 * True when the logged-in user is a "Center" user — what Rails calls
 * `center_user?` via `LocalStore.current_ability.center`. In the new
 * auth model this maps to `subcontractor === CLIENT_POOL (3)`.
 */
export function isCenterUser(user: User | null | undefined): boolean {
  return user?.subcontractor === SUBCONTRACTOR_TYPE.CLIENT_POOL;
}

/**
 * True when the logged-in user belongs to a subcontractor company — what
 * Rails calls `current_ability.subcontractor?`. Maps to
 * `subcontractor === COMPANY (1)` in the new auth model.
 */
export function isSubcontractorUser(user: User | null | undefined): boolean {
  return user?.subcontractor === SUBCONTRACTOR_TYPE.COMPANY;
}

/**
 * Mirrors legacy Rails `Util.eco_center_funding_source_display?`.
 *
 * Non-Center users always see the funding-source dropdown on trip-booking
 * forms. Center users only see it when the customer has enabled
 * `component.centers.fundingSource.enabled` in their configuration.
 *
 * @param user the authenticated user (null/undefined → treated as non-center)
 * @param isConfigEnabled value of `isFeatureEnabled('component.centers.fundingSource.enabled')`
 */
export function shouldShowFundingSourceForUser(
  user: User | null | undefined,
  isConfigEnabled: boolean,
): boolean {
  if (!isCenterUser(user)) return true;
  return isConfigEnabled;
}
